import {
  Filter
} from '../../common/filter';

require('./filter-stamp.component.scss');

class SilterStampController {
  constructor(
    CurrentModelService,
  ) {
    this.CurrentModelService = CurrentModelService;
    this.locLabel = Filter.locLabel;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  cutDimension(cut) {
    return this.CurrentModelService.model.getDrillLabel(cut.dimension);
  }

  cutValue(cut) {
    return this.locLabel(cut);
  }
}

export const SilterStampComponent = {
  template: require('./filter-stamp.component.html'),
  bindings: {
    filter: '<',
  },
  controller: SilterStampController,
};



// WEBPACK FOOTER //
// ./src/shared/filter-stamp/filter-stamp.component.js